import courses from './courses';
import cuisines from './cuisines';
import miniBrowse from './miniBrowse';
import ratings from './ratings';
import recipe from './recipe';
import { cuisineCountConfig, courseCountConfig, ratingCountConfig, seasonCountConfig, tagCountConfig } from './browse';
import search from './search';
import seasons from './seasons';
import tags from './tags';

const config = [
  courseCountConfig,
  courses,
  cuisineCountConfig,
  cuisines,
  miniBrowse,
  ratingCountConfig,
  ratings,
  recipe,
  search,
  seasonCountConfig,
  seasons,
  tagCountConfig,
  tags,
];

export default config;
